<template>
  <q-layout view="lhh LpR lff">
    <q-page-container>
      <q-page padding ref="qPage">
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
        <q-card class="row q-my-xs">
          <div class="col-12 q-pa-md">
            <div class="text-h5 text-center q-py-md">Kế hoạch</div>
          </div>
          <div class="col-xs-12 col-md-12 col-lg-9 q-pa-md row">
            <div class="col-xs-12 col-sm-5 col-md-4 q-pa-md">
              <q-select clearable emit-value v-model="farm" :options="farmStore.list" option-value="id" option-label="name" :display-value="$getNameById(farmStore.list, farm ,'name')" label="Nông trường">
                <template v-slot:prepend>
                  <q-icon name="filter_vintage" />
                </template>
              </q-select>
            </div>
            <div class="col-xs-6 col-sm col-md-4 q-pa-md">
              <div class="row">
                <q-input class="col self-center" v-model="month" label="Tháng" readonly></q-input>
                <q-btn icon="close" size="20px" style="height: 25%" flat class="col-1 cursor-pointer " v-if="month" @click="month = null; oldMonth = null"/>
                <q-btn icon="event" size="20px" style="height: 25%" flat class="col-2 cursor-pointer">
                  <q-popup-proxy>
                    <q-date ref="qMonth" v-model="modelMonth" minimal default-view="Months" v-close-popup='monthPopUp' @click="checkMonth()"/>
                  </q-popup-proxy>
                </q-btn>
              </div>
            </div>
            <div class="col-xs-6 col-sm col-md-4 q-pa-md">
              <div class="row">
                <q-input clearable class="col self-center" v-model="year" label="Năm" readonly></q-input>
                <q-btn icon="close" size="20px" style="height: 25%" flat class="col-1 cursor-pointer" v-if="year" @click="year = null; oldYear = null"/>
                <q-btn icon="event" size="20px" style="height: 25%" flat class="col-2 cursor-pointer">
                  <q-popup-proxy>
                    <q-date ref='qYear' v-model="modelYear" minimal default-view="Years" v-close-popup='yearPopUp' @click="checkYear()"/>
                  </q-popup-proxy>
                </q-btn>
              </div>
            </div>
          </div>
        </q-card>
        <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
        <q-table
          :data="plansData"
          :columns="headers"
          row-key="fieldName"
          no-data-label="Không có dữ liệu"
          :key="tableKey"
          :loading="load"
          :pagination= {rowsPerPage:20}
          :hide-bottom="plansData.length > 0 && plansData.length <= 20"
          >
          <template v-slot:body ="props">
            <q-tr :props="props" v-if="!props.row.deleted">
              <q-td @click.native="routeData(props.row._id)" class="label-xs-right text-center">{{ props.row.__index+1 }}</q-td>
              <q-td @click.native="routeData(props.row._id)" v-if="props.colsMap.farm" class="label-xs-right text-center">{{ props.row.farm ? $getNameById(farmStore.list, props.row.farm, 'name') : '' }}</q-td>
              <q-td @click.native="routeData(props.row._id)" v-if="props.colsMap.term" class="label-xs-right text-center">{{props.row.tag ? props.row.tag[props.row.tag.length-1] : ''}}</q-td>
              <q-td @click.native="routeData(props.row._id)" v-if="props.colsMap.time" class="label-xs-right text-center">{{ props.row.tag ? moment(props.row.tag.slice(0,props.row.tag.length-1), 'YYYYMM').format('MM/YYYY') : ''}}</q-td>
            </q-tr>
          </template>
        </q-table>
        <!-- Float add button -->
        <q-page-sticky class="q-ma-md item-center" :style="'right:unset; left: '+ ($q.screen.width/2 - 45) + 'px'">
          <q-btn fab icon="add" color="green" @click="routeData(null,'CREATE')"/>
        </q-page-sticky>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
<script>
/* eslint-disable no-unused-vars */
import { mapGetters } from 'vuex'
import firebase from '@firebase/app'
import { Promise } from 'q'
import {date} from 'quasar'
import Moment from 'moment'
export default {
  data() {
    return {
      headers: [
        {
          label: "No",
          align: "center",
          name: "no",
        },
        {
        label: "Nông trường",
        align: "center",
        name: "farm",
        },
        {
        label: "Kỳ",
        align: "center",
        name: "term",
        },
        {
        label: "Tháng / Năm",
        align: "center",
        name: "time",
        },
      ],
      yearPopUp: false,
      monthPopUp: false,
      load: false,
      plans: null,
      filterdR: [],
      farms: [],
      tableKey: 0,
      selectedRowIndex: null,
      defaultDateFormat: 'DD',
      loading: true,
      farm: null,
      modelMonth: '2019/06/06',
      modelYear: '2019/06/06',
      month: null,
      year: null,
      oldYear: null,
      oldMonth: null,
      moment: Moment
    }
  },
  async mounted() {
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      'user',
      'permission',
      'isAnonymous',
      'farmStore',
      'mekaStore',
      'jobStore'
    ]),
    plansData() {
      this.month
      this.year
      let vm = this
      let data = !vm.plans ? []
      : vm.plans.filter(v => {
        return vm.isRightTag(v) && (vm.farm ? vm._.isEqual(v.farm,vm.farm) : true)
      })
      return data.sort((a,b) => b.tag.localeCompare(a.tag) === 0 ? a.farm-b.farm : b.tag.localeCompare(a.tag))
    },
  },
  methods: {
    async fetchData () {
      this.load = true
      this.plans = null
      let d = this.filterData()
      let f = this.farmStore
      Promise.all([d, f]).then(res => {
        this.plans = res[0]
        this.farms = res[1].list
        this.load = false
      })
    },
    filterData() {
      const regexFarm = /(^F[0-9]M$)/
      let roles = this.permission.roles
      return this.$query(['Plans']).then(data => {
        if(roles.hasOwnProperty('BOM')) {
          return data.data
        } else {
          let fm = Object.keys(roles).filter((item) => regexFarm.test(item))
          let fmI = Object.keys(roles).filter((item) => regexFarm.test(item)).map(i => i[1])
          let filter = []
          data.data.forEach(item => {
            if(this._.get(item, ['metadata', 'permission'])) {
              let permission = Object.keys(item.metadata.permission)
              if(this._.intersection(fm, permission).length > 0) {
                filter.push(item)
              }
            }
          })
          // console.log(filter)
          return filter
        }
      })
    },
    routeData(id, mode) {
      this.$router.push({
        name: '/plans/entry',
        query: {
          id: id ? id : undefined,
        },
        params: {
          id: id,
          mode: mode ? mode : undefined
        }
      });
    },
    checkMonth() {
      this.modelMonth = '2019/'+ (this.$refs.qMonth.innerModel.month < 10 ? '0' :'') + this.$refs.qMonth.innerModel.month + '/06'
      this.month = this.$refs.qMonth.innerModel.month
      if (this.oldMonth - this.month !== 0) {
        this.oldMonth = this.month
        this.monthPopUp = true
      }
      else {
        this.$refs.qMonth.view = "Months"
        this.monthPopUp = false
      }
    },
    checkYear() {
      this.modelYear = this.$refs.qYear.innerModel.year + '/06/06'
        this.year = this.$refs.qYear.innerModel.year
        if (this.oldYear - this.year !== 0) {
          this.oldYear = this.year
         this.yearPopUp = true
        }
        else {
          this.$refs.qYear.view = "Years"
          this.yearPopUp = false
        }
    },
    isRightTag(item) {
      if (!this.month && !this.year) return true
      if (this.month) {
        let m = (this.month < 10 ? '0' : '') + this.month
        if (this.year) {
          return item.tag.indexOf(this.year + '' + m) > -1
        }
        return item.tag.slice(4,6).indexOf(m) > -1
      }
      else {
          return item.tag.slice(0,4).indexOf(this.year) > -1
      }
    }
  }
}
</script>
